// @ts-nocheck

class SlideModal {
  constructor() {
    this.modals = document.querySelectorAll('[data-slide-modal]');
    if (!this.modals.length) return;

    this.activeModal = null;
    this.onKey = (e) => {
      if (e.key === 'Escape') this.close(this.activeModal);
    };

    this.modals.forEach((modal) => {
      document.body.appendChild(modal);
      modal.querySelectorAll('[data-slide-modal-close]').forEach((closer) => {
        closer.addEventListener('click', () => this.close(modal));
      });
    });

    document.querySelectorAll('[data-slide-modal-open]').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const modal = document.querySelector('[data-slide-modal="' + trigger.getAttribute('data-slide-modal-open') + '"]');
        if (modal) this.open(modal);
      });
    });
  }

  open(modal) {
    const header = document.querySelector('.header-container');
    const offset = header ? Math.max(header.getBoundingClientRect().bottom, 0) : 0;
    modal.style.top = offset + 'px';
    modal.hidden = false;
    this.activeModal = modal;
    requestAnimationFrame(() => {
      requestAnimationFrame(() => modal.classList.add('is-open'));
    });
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', this.onKey);
  }

  close(modal) {
    if (!modal) return;
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
    document.removeEventListener('keydown', this.onKey);
    this.activeModal = null;
    const onEnd = (e) => {
      if (e.target !== modal || e.propertyName !== 'opacity') return;
      modal.hidden = true;
      modal.removeEventListener('transitionend', onEnd);
    };
    modal.addEventListener('transitionend', onEnd);
  }
}

new SlideModal();
